import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivitiesService } from 'src/app/services/activities-services/activities.service';
import { Json2csvService } from 'csvtools-lib';
import { DateUnixTransformerPipe } from 'src/app/pipes/date-unix-transformer-pipe/date-unix-transformer.pipe';
import { tap } from 'rxjs/internal/operators/tap';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-activities-sms-consumption-breadcrumb-card',
  templateUrl: './activities-sms-consumption-breadcrumb-card.component.html',
  styleUrls: ['./activities-sms-consumption-breadcrumb-card.component.scss']
})
export class ActivitiesSmsConsumptionBreadcrumbCardComponent implements OnInit, OnDestroy {

  csvData;
  filterSmsConsumptionForm = new FormGroup({
    dateFrom: new FormControl(null, Validators.required),
    dateTo: new FormControl(null, Validators.required)
  });
  listenSmsConsumptionRefreshSubscription: Subscription;

  constructor(private json2csvService: Json2csvService,
    private dateUnixTransformerPipe: DateUnixTransformerPipe,
    private activitiesService: ActivitiesService) { }

  ngOnInit() {
    this.listenSmsConsumptionRefreshSubscription = this.activitiesService.listenSmsConsumptionRefresh().pipe(
      tap(res => this.csvData = res)
    ).subscribe();
  }

  public generateCSV() {
    this.csvData.forEach(i => i['statsDate'] = this.dateUnixTransformerPipe.transform(i['statsDate'], 'false'));
    this.json2csvService.setBody(this.csvData, ['StatsDate', 'CenterInternalId', 'SmsOrigin', 'CounterError', 'CounterOk']);
    this.json2csvService.setHeader(['Date', 'Center', 'Origin', 'CounterError', 'CounterOk']);
    this.json2csvService.generateCSV('sms-statistics');
  }

  public valueChanges(e) {
    if (this.filterSmsConsumptionForm.get('dateFrom').value && this.filterSmsConsumptionForm.get('dateTo').value) {
      this.activitiesService.smsConsumptionSearch(this.filterSmsConsumptionForm.get('dateFrom').value.valueOf(), this.filterSmsConsumptionForm.get('dateTo').value.valueOf());
    }
  }

  public clearField(fieldName) {
    this.filterSmsConsumptionForm.patchValue({
      [fieldName]: null
    });
  }

  ngOnDestroy() {
    if (this.listenSmsConsumptionRefreshSubscription) { this.listenSmsConsumptionRefreshSubscription.unsubscribe(); }
  }
}
